import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BusinessPage from '../pages/expert/BusinessPage';
import CheckoutFinishedPage from '../pages/expert/CheckoutFinishedPage';
import TeamSettingsPage from '../pages/expert/TeamSettingsPage';
import AgentProfilePage from '../pages/expert/AgentProfilePage';
import BillingPage from '../pages/expert/BillingPage';
import MeetingsPage from '../pages/expert/MeetingsPage';
import MeetSettingsPage from '../pages/expert/MeetSettingsPage';
import ServiceDetailsPage from '../pages/expert/ServiceDetailsPage';
import LeadsPage from '../pages/expert/LeadsPage';
import SupportPage from '../pages/expert/SupportPage';
import RequiresExpertRoute from '../components/RequiresExpertRoute';

export default function ExpertRoutes() {
  return (
    <Routes>
      <Route path="business">
        <Route index element={<RequiresExpertRoute><BusinessPage /></RequiresExpertRoute>} />
      </Route>
      <Route path="service-details" element={<RequiresExpertRoute><ServiceDetailsPage /></RequiresExpertRoute>} />
      <Route path="team" element={<RequiresExpertRoute><TeamSettingsPage /></RequiresExpertRoute>} />
      <Route path="profile" element={<RequiresExpertRoute><AgentProfilePage /></RequiresExpertRoute>} />
      <Route path="meet">
        <Route index element={<RequiresExpertRoute><MeetingsPage /></RequiresExpertRoute>} />
        <Route path="settings" element={<RequiresExpertRoute><MeetSettingsPage /></RequiresExpertRoute>} />
      </Route>
      <Route path="collect">
        <Route index element={<RequiresExpertRoute><LeadsPage /></RequiresExpertRoute>} />
      </Route>
      <Route path="billing" element={<BillingPage />} />
      <Route path="checkout-finished" element={<CheckoutFinishedPage />} />
      <Route path="support" element={<SupportPage />} />
      <Route path="" element={<Navigate to="business" replace />} />
    </Routes>
  );
}
